var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarlyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13654_56398",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5625,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13654_56398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 18C4.65 18 4.29687 17.8531 4.00312 17.5594C3.70937 17.2656 3.5625 16.9125 3.5625 16.5V5.5C3.5625 5.0875 3.70937 4.73438 4.00312 4.44063C4.29687 4.14688 4.65 4 5.0625 4H6.5625V2.75C6.5625 2.5375 6.63396 2.35937 6.77688 2.21562C6.91979 2.07187 7.09688 2 7.30813 2C7.51938 2 7.69792 2.07187 7.84375 2.21562C7.98958 2.35937 8.0625 2.5375 8.0625 2.75V4H13.0625V2.75C13.0625 2.5375 13.134 2.35937 13.2769 2.21562C13.4198 2.07187 13.5969 2 13.8081 2C14.0194 2 14.1979 2.07187 14.3438 2.21562C14.4896 2.35937 14.5625 2.5375 14.5625 2.75V4H16.0625C16.475 4 16.8281 4.14688 17.1219 4.44063C17.4156 4.73438 17.5625 5.0875 17.5625 5.5V8.25C17.5625 8.4625 17.4906 8.64063 17.3469 8.78438C17.2031 8.92813 17.025 9 16.8125 9H5.0625V16.5H8.3125C8.525 16.5 8.70312 16.5715 8.84688 16.7144C8.99063 16.8573 9.0625 17.0344 9.0625 17.2456C9.0625 17.4569 8.99063 17.6354 8.84688 17.7812C8.70312 17.9271 8.525 18 8.3125 18H5.0625ZM5.0625 7.5H16.0625V5.5H5.0625V7.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4179 17.5618L16.441 18.7812C16.6443 18.8921 16.8336 18.8782 17.0091 18.7397C17.1847 18.6011 17.2447 18.4302 17.1893 18.227L16.635 15.9558L18.4048 14.4158C18.5737 14.2591 18.6262 14.0742 18.5625 13.861C18.4986 13.6478 18.3549 13.5327 18.1316 13.5157L15.8083 13.3314L14.8946 11.1714C14.8076 10.9606 14.651 10.8552 14.4249 10.8552C14.1985 10.8552 14.0417 10.9606 13.9543 11.1714L13.037 13.3314L10.7043 13.5157C10.4809 13.5327 10.3373 13.6478 10.2734 13.861C10.2096 14.0742 10.2622 14.2591 10.431 14.4158L12.2008 15.9558L11.6466 18.227C11.5911 18.4302 11.6512 18.6011 11.8267 18.7397C12.0022 18.8782 12.1916 18.8921 12.3948 18.7812L14.4179 17.5618Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyOn);
export default __webpack_public_path__ + "static/media/early_on.ccd39b6ead85f290476bee97533b01a2.svg";
export { ForwardRef as ReactComponent };